var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-label": "Jira",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 6H31a12 12 0 0 0 12 12h5v5a12 12 0 0 0 12 12V8a2 2 0 0 0-2-2z",
    fill: "#2684ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 19.5h-27a12 12 0 0 0 12 12h5v5a12 12 0 0 0 12 12v-27a2 2 0 0 0-2-2z",
    fill: "#1d78f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33H4a12 12 0 0 0 12 12h5v5a12 12 0 0 0 12 12V35a2 2 0 0 0-2-2z",
    fill: "#0052cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.0abb52cfdf0a2fbf523ac7901dbc659b.svg";
export { ForwardRef as ReactComponent };